<ng-container [ngSwitch]="mode">
	<app-month-range-picker *ngSwitchCase="'month'" [doubleValue]="value" [date]="date"
		(doubleValueChange)="setValue($event);" (changePicker)="askYearView($event)">
	</app-month-range-picker>

	<app-year-picker *ngSwitchCase="'year'" [value]="date" [typeRange]="true" (valueChange)="askMonthView($event);"
		(changePicker)="askDecadeView($event)">
	</app-year-picker>

	<app-decade-picker *ngSwitchCase="'decade'" [value]="date" [typeRange]="true" (valueChange)="askYearView($event)">
	</app-decade-picker>
</ng-container>